<template>
  <bita-modal
      :id="modalId"
      :title="title"
      :modal-md="true"
      :is-loading="isLoading"
      @close="onCloseModal"
  >
    <div slot="body">
      <div class="list">
        <div class="item" :class="{active: index % 2}" v-for="(item, index) in items" :key="index">
          <span class="title">{{item.name}}:</span>
          <span class="value">{{driver[item.value]}}</span>
        </div>
      </div>
    </div>
  </bita-modal>
</template>
<script>
import LabelValue from "./LabelValue";


export default {
  components: { LabelValue },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
  },
  data() {
    return {
      driver: {},
      items: [
        {
          name: "نام و نام خانوادگی",
          value: "name"
        },
        {
          name: "کد ملی",
          value: "national_code"
        },
        {
          name: "شماره پلاک",
          value: "number_plate"
        },
        {
          name: "هوشمند ماشین",
          value: "car_smartnumber"
        },
        {
          name: "شماره تماس",
          value: "phone"
        },
      ]
    };
  },
  methods: {
    onCloseModal() {
      this.driver = {}
    },

    init({requestDetail}) {
      const requestTicketDetail = requestDetail.request_ticket_detail || {};

      if (requestTicketDetail.id) {
        this.driver = {...requestTicketDetail}
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-direction: column;

  .item {
    display: flex;
    gap: 5px;
    padding: 8px 6px;
    border-radius: 3px;

    &.active {
      background-color: rgb(241, 240, 240);
    }

    .title {
      flex: 0 1 30%;
      color: #18a689;
    }
  }
}
</style>